import script from "./CutBoxEndModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CutBoxEndModal.vue?vue&type=script&setup=true&lang=ts"

import "./CutBoxEndModal.vue?vue&type=style&index=0&id=65835182&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65835182"]])

export default __exports__